import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchPageBySlug, getLocalizedValue } from '../lib/cms';
import usePageMetadata from '../hooks/usePageMetadata';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export default function NotFound() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { language } = useLanguage();
  const t = translations[language];

  useEffect(() => {
    async function loadData() {
      try {
        const page = await fetchPageBySlug('404');
        setPageData(page);
      } catch (err) {
        console.error('Error loading 404 page:', err);
      } finally {
        setLoading(false);
      }
    }
    loadData();
  }, []);

  // Set page metadata
  const title = pageData ? getLocalizedValue(pageData.meta_title, language) : '404 - Siden blev ikke fundet - Insightly ApS';
  const description = pageData ? getLocalizedValue(pageData.meta_description, language) : 'Siden du leder efter, findes desværre ikke.';
  usePageMetadata(title, description);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-offwhite">
        <div className="flex flex-col items-center gap-3">
          <i className="fa-solid fa-spinner animate-spin text-3xl text-petrol"></i>
          <p className="text-sm text-navy-900/60 font-medium">Henter indhold...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-offwhite min-h-[70vh] flex items-center justify-center py-12 md:py-20">
      <div className="max-w-xl mx-auto px-4 text-center space-y-6">
        <div className="inline-flex h-20 w-20 items-center justify-center rounded-full bg-navy-50 text-navy-900 mb-4 border border-bluegray">
          <i className="fa-light fa-circle-question text-4xl text-petrol"></i>
        </div>
        <h1 className="text-4xl font-serif font-bold text-navy-900">
          {pageData ? getLocalizedValue(pageData.title, language) : t.errors.notFound}
        </h1>
        <div 
          className="text-navy-900/70 leading-relaxed font-sans text-base"
          dangerouslySetInnerHTML={{ __html: pageData ? getLocalizedValue(pageData.content, language) : `<p>${t.errors.notFoundDesc}</p>` }}
        />
        <div className="pt-6 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="bg-navy-900 hover:bg-petrol text-offwhite px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-sm"
          >
            {t.errors.backHome}
          </Link>
          <Link
            to="/kontakt"
            className="bg-white hover:bg-navy-50 text-navy-900 border border-bluegray px-6 py-3 rounded-lg font-semibold transition-all duration-300 shadow-sm"
          >
            {t.nav.contact}
          </Link>
        </div>
      </div>
    </div>
  );
}
